import { useQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { majorClient } from '../client/majorClient';

type Options = {
  enabled?: boolean;
};

const defaultOptions: Partial<Options> = {
  enabled: true,
};

export const useMajorsQuery = (params: Majors.GetListParams = {}, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useQuery({
    queryKey: [cacheKeys.getMajors, params],
    queryFn: () => majorClient.getMajors(params),
    ...options,
  });

  return {
    ...rest,
    count: data?.count || 0,
    majors: data?.results || [],
  };
};
